export enum AdminTypes {
  SystemAdmin = "SystemAdmin",
  ForumAdmin = "ForumAdmin",
}
